import { createFileRoute } from '@tanstack/react-router'
import { CrossOrgPage } from '@/features/cross-org'

export const Route = createFileRoute('/_authenticated/_organization/cross-org')({
  component: CrossOrgPage,
})
